import { render, staticRenderFns } from "./Morepage.vue?vue&type=template&id=74f99816&scoped=true"
import script from "./Morepage.vue?vue&type=script&lang=js"
export * from "./Morepage.vue?vue&type=script&lang=js"
import style0 from "./Morepage.vue?vue&type=style&index=0&id=74f99816&prod&lang=scss&scoped=true"
import style1 from "./Morepage.vue?vue&type=style&index=1&id=74f99816&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.21_css-loader@6.11.0_webpack@5.101.3__lodash@4.17.21_kzgbr7tkrfh4tbz6eswufdvi6i/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f99816",
  null
  
)

export default component.exports